import {defineStore} from 'pinia'
import {fetchWrapper} from '@/wrappers/api/fetchWrapper'

export const usePricesStore = defineStore('prices', {
    state: () => ({
        prices: [],
        paymentMethods: [
            {
                locationId: 1, types: ['pay_at_location']
            }
        ],
        isLoading: false,
        error: null,
        initialized: false
    }),
    actions: {
        init() {
            if (!this.initialized && !this.isLoading) {
                this.initialized = true;
                this.fetchPrices(1);
            }
        },
        setPrices(prices) {
            this.prices = prices;
        },
        async fetchPrices(locationId = 1) {
            this.isLoading = true;
            this.error = null;
            try {
                const data = await fetchWrapper.get(`/locations/${locationId}`);
                const pricePerHour = data?.prices?.per_hour?.hours || {};
                const currency = data?.prices?.per_hour?.currency || 'PLN';

                const newPriceConfig = {
                    locationId: Number(locationId),
                    pricePerHour,
                    currency
                };

                const existingIndex = this.prices.findIndex(p => p.locationId === Number(locationId));
                if (existingIndex !== -1) {
                    this.prices[existingIndex] = newPriceConfig;
                } else {
                    this.prices.push(newPriceConfig);
                }

                return data;
            } catch (err) {
                this.error = err;
                throw err;
            } finally {
                this.isLoading = false;
            }
        }
    },
    getters: {
        getPriceByLocationId: (state) => function(locationId) {
            const store = usePricesStore();
            store.init();

            const found = state.prices.find(p => p.locationId === Number(locationId));
            if (!found && !state.isLoading && !state.error) {
                store.fetchPrices(locationId);
            }
            return found;
        },
        getPaymentMethodsByLocationId: (state) => (locationId) => {
            const config = state.paymentMethods.find(pm => pm.locationId === Number(locationId));
            return config ? config.types : [];
        },
        calculatePrice: (state) => function(locationId, duration) {
            const store = usePricesStore();
            store.init();

            let priceConfig = state.prices.find(p => p.locationId === Number(locationId));
            if (!priceConfig && !state.isLoading && !state.error) {
                store.fetchPrices(locationId);
            }

            if (!priceConfig || !duration) return 0;

            const [hours, minutes] = duration.split(':').map(Number);
            const totalHours = hours + (minutes / 60);

            // Get all keys (hours) as numbers and sort them ascending
            const tiers = Object.keys(priceConfig.pricePerHour).map(Number).sort((a, b) => a - b);

            // Find the correct rate: either the exact match or the highest available if exceeded
            let hourlyRate = 0;
            for (const tier of tiers) {
                if (totalHours >= tier) {
                    hourlyRate = priceConfig.pricePerHour[tier];
                }
            }

            // Fallback to the first tier if totalHours is somehow less than the smallest tier (e.g., 0.5h)
            if (hourlyRate === 0 && tiers.length > 0) {
                hourlyRate = priceConfig.pricePerHour[tiers[0]];
            }

            return totalHours * hourlyRate;
        }
    },
    persist: false
})